import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InfoFieldRow } from '../../../store/models/info-field.model';

@Component({
  selector: 'ui-info-field-list',
  templateUrl: './info-field-list.component.html',
  styleUrls: ['./info-field-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoFieldListComponent {
  @Input() title: string;
  @Input() rows: InfoFieldRow[];
  @Input() flat = false;
}
